import { Button } from "@/components/ui/button";
import { ACTIVITY_PRESETS } from "@/lib/presets";
import { Badge } from "@/components/ui/badge";
import { Zap } from "lucide-react";

interface PresetSelectorProps {
  unitSystem: "metric" | "imperial";
  onSelectPreset: (preset: typeof ACTIVITY_PRESETS[0]) => void;
}

const PresetSelector = ({ unitSystem, onSelectPreset }: PresetSelectorProps) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Zap className="w-4 h-4 text-accent" />
        <h3 className="text-sm font-semibold text-foreground">Quick Presets</h3>
        <Badge variant="secondary" className="text-xs">Popular</Badge>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {ACTIVITY_PRESETS.map((preset) => (
          <Button
            key={preset.id}
            variant="outline"
            size="sm"
            onClick={() => onSelectPreset(preset)}
            className="h-auto py-3 px-3 flex flex-col items-start text-left hover:bg-accent/10 hover:border-accent transition-colors group"
          >
            <span className="font-semibold text-xs mb-1 text-foreground group-hover:text-foreground">{preset.name}</span>
            <span className="text-xs text-muted-foreground group-hover:text-foreground/80">
              {unitSystem === "metric" ? preset.speed.metric : preset.speed.imperial}{" "}
              {unitSystem === "metric" ? "km/h" : "mph"}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default PresetSelector;
